import './SystemPopup.css';

import { useCallback, useMemo } from 'react';

import { Button } from '../buttons/Button';
import { CssClassNameBuilder } from '../../utils/CssClassNameBuilder';
import { PopupContainer } from '../../layouts/containers/popup-container/PopupContainer';
import { Spacer } from '../separator/Spacer';
import {ReactComponent as SuccessIcon} from '../../assets/icons/success-icon.svg';
import { useClosePopup } from '../../infrastructure/ui/UIServices';

interface ISuccessPopupProps {
    children: React.ReactNode;
    className?: string;
    onDismissClicked?: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}


export function SuccessPopup(props: ISuccessPopupProps){
    const closePopup = useClosePopup();

    const popupCss = useMemo(() => {
        return CssClassNameBuilder.new()
            .add("system-popup")
            .add("success-popup")
            .addConditional(props.className, props.className)
            .build();
    }, [props.className]);


    const handleClicked = useCallback((ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        ev.stopPropagation();
        props.onDismissClicked && props.onDismissClicked(ev);
        closePopup();
    }, [props.onDismissClicked]);

    return (
        <PopupContainer className={popupCss}>
            <div className="popup-icon"><SuccessIcon /></div>
            <Spacer px="14" mode="vertical" />
            <div className="popup-header">Success!</div>

            <Spacer px="6" mode="vertical" />
            <div className="popup-content">
                {props.children}
            </div>
            <Spacer px="24" mode="vertical" />
            <div className="popup-actions">
                <Button text="Ok" type="primary" onClick={handleClicked} />
            </div>
        </PopupContainer>
    );
}
